import clsx from "clsx";
import DOMPurify from "dompurify";

export const RichTextDisplay = ({
  className,
  richText,
}: {
  className?: string;
  richText: string;
}) => {
  const sanitizedRichText = DOMPurify.sanitize(richText);

  return (
    <div
      className={clsx("tiptap", className)}
      dangerouslySetInnerHTML={{ __html: sanitizedRichText }}
    ></div>
  );
};
